'use client'

import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import styles from './styles.module.css'
import { getStrapiImageUrl } from '@/lib/strapi'

interface MediaImage {
  url?: string
  alternativeText?: string
  formats?: any
  data?: {
    attributes?: {
      url?: string
      alternativeText?: string
      formats?: any
    }
  }
}

interface FullScreenImgData {
  img_desctop?: MediaImage
  img_tablet?: MediaImage
  img_mobile?: MediaImage
}

interface Props {
  data: FullScreenImgData
}

const extractImageUrl = (img?: MediaImage): { url: string; alt: string } => {
  if (!img) return { url: '', alt: '' }

  // img.data.attributes.url
  if (img.data?.attributes?.url) {
    return {
      url: getStrapiImageUrl(img.data.attributes.url),
      alt: img.data.attributes.alternativeText || ''
    }
  }

  // img.url
  if (img.url) {
    return {
      url: getStrapiImageUrl(img.url),
      alt: img.alternativeText || ''
    }
  }

  return { url: '', alt: '' }
}

const FullScreenImg: React.FC<Props> = ({ data }) => {
  const [screenSize, setScreenSize] = useState<'desktop' | 'tablet' | 'mobile'>('desktop')

  // определяем ширину экрана
  useEffect(() => {
    const checkSize = () => {
      const width = window.innerWidth
      if (width <= 767) {
        setScreenSize('mobile')
      } else if (width <= 1439) {
        setScreenSize('tablet')
      } else {
        setScreenSize('desktop')
      }
    }
    checkSize()
    window.addEventListener('resize', checkSize)
    return () => window.removeEventListener('resize', checkSize)
  }, [])

  // достаем урлы
  const desk = extractImageUrl(data.img_desctop)
  const tablet = extractImageUrl(data.img_tablet)
  const mob = extractImageUrl(data.img_mobile)

  // выбираем изображение с fallback
  let imageToShow = desk
  if (screenSize === 'mobile') {
    imageToShow = mob.url ? mob : (tablet.url ? tablet : desk)
  } else if (screenSize === 'tablet') {
    imageToShow = tablet.url ? tablet : desk
  }

  if (!imageToShow.url) return null

  return (
    <div className={styles.wrapper}>
      <Image
        src={imageToShow.url}
        alt={imageToShow.alt || ''}
        width={2000}
        height={1000}
        className={styles.fullImg}
        priority
      />
    </div>
  )
}

export default FullScreenImg
